import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { InputLoad } from "components/InputLoading/inputLoading";
import { SelectBox } from "components/Select/Select";
import { InputHTMLAttributes, useEffect, useState } from "react";
import { ICON_TYPE } from "utils/constants";
import "./style.scss";
import { getMultiSelect } from "./api";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { trans } from "utils/helpers";
interface WarehouseDictionarySelectProp
  extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  value?: any;
  PriceListObj?: any;
  mode?: any;
  required?: boolean;
  Change?: (e) => void;
  setSelectedList?: (e) => void;
  selectedItemCallBack?: (e) => void;
  returnObj?: boolean;
  url?:any
  baseUrl?:any
  params?:any
  keys?:any

}
export const MultiSelectBox = ({
  label,
  name,
  value,
  mode,
  required,
  url,
  baseUrl,
  params,
  keys
}: WarehouseDictionarySelectProp) => {

  const [errcode, setErrcode] = useState<any>();
  const [selectedItemList, setSelectedItemList] = useState<any>([]);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectBox,setSelectBox]=useState<any>()
  const [loading, setLoading] = useState(false);


  const multiSelectAsync = async () => {

      const res = await getMultiSelect(baseUrl,url,params);

      const data=[] as any
 
        if(res.Data?.Data && !!res.Data?.Data?.length)
//Data:{Data:[{},{},{}],TotalRecords:3,...} 

{   
  console.log('a');
  
  res.Data.Data.map(item=>{
          let str='' as any
          (!!keys.length?keys:Object.keys(item)).map((item1,index)=>{
            console.log(index==(!!keys.length?keys?.length:Object.keys(item)?.length),'yyy');
            
    if(index==(!!keys.length?keys?.length:Object.keys(item)?.length)-1){
      str+=item?.[item1]
    }else{

      str+=item?.[item1]+ " - "
    }
  })
  if(str!='undefined')  data.push(str)
})
}
else if(res.Data && Object.values(res.Data) && Object.values(res.Data)?.length){
//Data:{id:value,id:value,id:value} || Data:{id:{},id:{},id:{}} 

  console.log('b');
  
   Object.values(res.Data).map((item:any,index:any)=>{
          let str='' as any
          console.log(Object.values(item),'rrrr');
          
          if(typeof item=="string" || typeof item=='number'){
             data.push(item)
          }
else{
            (!!keys.length?keys:Object.keys(item)).map((item1,index1)=>{
    if(index1==(!!keys.length?keys?.length:Object.keys(item)?.length)-1){
      str+=item?.[item1]
    }else{

      str+=item?.[item1]+ " - "
    }
  })
if(str!='undefined')  data.push(str)
}
})
console.log(data,'test');

}
else if(res.Data && res.Data?.length){
//Data:[{},{},{}]
   res.Data.map(item=>{
          let str='' as any
          (!!keys.length?keys:Object.keys(item)).map((item1,index)=>{
    if(index==(!!keys.length?keys?.length:Object.keys(item)?.length)-1){
      str+=item?.[item1]
    }else{

      str+=item?.[item1]+ " - "
    }
  })
  if(str!='undefined')  data.push(str)
 
})
}
      setSelectedItem((prev)=>prev?prev:data?.[0])
      setSelectBox(data)
  };

  function addOption(e) {
    
    e.stopPropagation();
    e.preventDefault();
    if(!selectedItemList?.includes(selectedItem)) setSelectedItemList([...selectedItemList,selectedItem])
   
    
  }

  async function deleteaOption(Id) {
    let data = JSON.parse(JSON.stringify(selectedItemList))
     
    setSelectedItemList(data.filter(item=>item!=Id));

    
    if (Id == selectedItem) {
      setSelectedItem(data.filter(item=>item!=Id)?.[0]);
    }
  }







  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [loading]);
  useEffect(() => {
    multiSelectAsync();
  }, []);


useEffect(()=>{
  if(value){
    setSelectedItemList(value?.split(','))
    setSelectedItem(value?.split(',')?.[0])
  }
},[value])
  
console.log({mode});

  return (
    <>
      {true ? (
        <>
      <div className="row align-items-start">
<div className="col-6 row align-items-center">
  <div className="col ps-0">
    <input type="text" className="d-none" value={selectedItemList.join()} name={name} id="" />
         <SelectBox
                  name={name+"SelectBox"}
                  lable={label}
  
                  onChange={(e) => {
                   setSelectedItem(e.target.value)
                  }}
                  
                  options={!!selectBox?.length?selectBox:[]}
                  val={!!selectBox?.length?selectBox:[]}
                  required={required}
                  selectType="multiSelect"
                  value={selectedItem}
                  mode={mode}
                />
  </div>
      
          
         <div className="col-auto">
  <div style={{ marginTop: "20px", width: "10%" }}>
              <Button
                Icon={true}
                disabled={false}
                    // onClick={addOption}

                value={
                  <button
                    disabled={false}
                    onClick={addOption}
                    className={`checkButton`}
                  >
                    {" "}
                    <FontAwesomeIcon icon={[ICON_TYPE, "check"]} size="2x" />
                  </button>
                }
                btnType="primaryFill"
              />
            </div>
         </div>

          


</div>
<div className="col-6 mt-2">
   <div className="group-person__selected-options-wrWarehouseer mt-2 row gy-1">
          {selectedItemList.map((item, index) => (
              <div
                className={`mx-1 group-person__selected-option form-control-custom w-auto col-auto`}
                key={item + index}
                style={ mode=='view' ? {backgroundColor:'#e9ecef'}:{}}
              >
           


  <OverlayTrigger
            key={index}
            placement="top"
            delay={{ show: 600, hide: 0 }}
            overlay={
              <Tooltip className="tooltip " id={`button-tooltip-${"reserve"}`}>
                {trans(item)}
              </Tooltip>
            }
          >
                    <div
                  style={{
                    marginRight: true ? "0" : "13px",
                  }}
                  className="ms-1 showDots"
                >
                  {item}
                </div>
          </OverlayTrigger>
       
                <div
                  className="group-person__delete-selected-option "
                  data-key={item}
                  onClick={() => {
                    deleteaOption(item);
                  }}
                >
                  <FontAwesomeIcon icon={[ICON_TYPE, "times"]} />
                </div>
              </div>
            ))}
          </div>
</div>


      </div>
   
     
         
        </>
      ) : (
        <InputLoad
          msg={errcode}
          required={required}
          labelText={label}
          onClick={multiSelectAsync}
        />
      )}
      <div className="text-box__msg-wrWarehouseer"></div>
    </>
  );
};
